/**
 * payment 앱 색상 상수.
 *
 * @ugleelab/design-system 토큰에는 원색 팔레트만 있고 시맨틱 레이어(fg/bg/stroke/brand)가
 * 아직 없어, Figma 시안의 색상을 여기서 단일 출처로 관리한다. 디자인 시스템에 시맨틱 토큰이
 * 추가되면 이 파일을 제거하고 theme 호출로 마이그레이션.
 */
export const COLORS = {
  // Brand
  brand: '#FF5626',

  // Background
  bgWhite: '#FFFFFF',
  bgSubtle: '#F5F5F6',
  bgTertiary: '#E8E8E8',
  bgDisabled: '#E4E5E7',
  bgInformativeSubtle: '#EFF6FF',
  bgInverse: '#1B1C1D',
  bgElevated: '#686A72',

  // Text / Foreground
  textPrimary: '#1B1C1D',
  textSecondary: '#3F4145',
  textTertiary: '#5D5F65',
  textMuted: '#85878E',
  textDisabled: '#B0B0B0',
  textPlaceholder: '#ACAEB4',
  textInverse: '#FFFFFF',

  // Status
  fgInformative: '#2563EB',
  fgNegative: '#DC2626',
  fgPositive: '#16A34A',
  bgPositiveSubtle: '#ECFDF5',
  bgNegative: '#EF4444',

  // Stroke
  borderDefault: '#E7E7E7',
  strokeInput: '#D4D5D8',
  strokeStatic: '#E4E5E7',
} as const
